import type { SponsorWidget as SponsorWidgetType } from '../../types/coach';
import Badge from '../atoms/Badge';
import Card from '../atoms/Card';
import ErrorState from '../molecules/ErrorState';

interface SponsorWidgetProps {
  widget: SponsorWidgetType;
}

export function SponsorWidget({ widget }: SponsorWidgetProps) {
  const { sponsor } = widget;

  // Defensive programming
  if (!sponsor) {
    return <ErrorState message="Invalid sponsor widget" />;
  }

  return (
    <Card variant="glass" hover className="max-w-sm">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          {sponsor.imageName ? (
            <img 
              src={`/images/sponsors/${sponsor.imageName}`} 
              alt={sponsor.name}
              className="w-12 h-12 rounded-xl object-cover shadow-sm"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const nextSibling = e.currentTarget.nextElementSibling as HTMLElement;
                if (nextSibling) {nextSibling.style.display = 'flex';}
              }}
            />
          ) : null}
          <div 
            className={`w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-sm ${sponsor.imageName ? 'hidden' : 'flex'}`}
          >
            <span className="text-lg font-semibold text-white">
              {sponsor.initials ?? sponsor.name.charAt(0)}
            </span>
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-text-primary truncate">
            {sponsor.name ?? 'Unknown Sponsor'}
          </h4>
          <Badge 
            variant="purple" 
            size="xs" 
            className="mt-2"
            icon={
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            }
          >
            Sponsor
          </Badge>
        </div>
      </div>
    </Card>
  );
}